export const environment = {
    API_REST_SERVICE_URL: 'https://suameca.banrep.gov.co', //'https://suameca.banrep.gov.co'
    APP_GRAFICADOR: 'https://suameca.banrep.gov.co/graficador-series/',
    APP_DESCARGA_MULTIPLE_DATOS: 'https://suameca.banrep.gov.co/buscador-de-series/',
    APP_INDICADORES_ECONOMICOS_DIA: 'https://suameca.banrep.gov.co/indicadores-economicos-del-dia/',
    URL_ORACLE_REPORT_DV: 'https://suameca.banrep.gov.co/estadisticas-economicas-back/reporte-oac.html?path=',
    TITULO_TRM_INTRADIA: 'Tasa de cambio del peso colombiano',
    SUBTITULO_TRM_INTRADIA: 'Comportamiento del mercado del dólar durante el día (información en tiempo real)',
};
